export const SUPPORTS_ARRAY_PROTOTYPE_CONCAT = "concat" in Array.prototype;
